import React, { useEffect, useState } from 'react';
import { Select, Input, Checkbox, InputNumber } from 'antd';
import './SurveyThemeOption.scss';
import './surveyBaseStyles.scss';
import { ThemeCSSEditor } from './themeCSSEditor';
import {
  getOnSiteDefaultAdvancedCss,
  isOnSiteLayoutFixOnly,
} from '../onsite/layoutFixCss';

import { useSelector } from 'react-redux';

const { Option } = Select;

const fontSizes = Array.from({ length: 10 }, (_, i) => (i + 6) * 2);
function normalizeFont(font) {
  if (!font) return font;

  return font.replace(/\.(ttf|woff|woff2)$/, '');
}
const layoutConfigurations = {
  IN_APP: {
    MODAL: ['title', 'message', 'primary-button', 'font', 'font-size'],
    CARD: [
      'title',
      'message',
      'primary-button',
      'secondary-button',
      'font',
      'font-size',
    ],
    IMAGE_ONLY: [],
    BANNER: ['title', 'message', 'font', 'font-size'],
    BANNER_RTL: ['title', 'message', 'font', 'font-size'],
    COUPON: [
      'title',
      'message',
      'coupon',
      'font',
      'font-size',
      'coupon_button',
    ],
  },
  ON_SITE: {
    TEXT: [
      'label',
      'title',
      'message',
      'primary-button',
      'border-radius',
      'font',
      'font-size',
    ],
    IMAGE: ['border-radius'],
    COUPON: [
      'title',
      'coupon',
      'message',
      'border-radius',
      'font',
      'font-size',
      'coupon_button',
    ],
  },
};

export default function ThemeAttributes({
  value,
  // theme,
  // setTheme,
  css,
  editMode,
  // setShowThemeAttributes,
  handleChangeProps,
  setIsBasicAttributesVisible,
  isBasicAttributesVisible,
  // handleCancel,
  // handleSave,
  layoutType,
  channel,
  readOnly,
}) {
  const [enabledCSS, setEnabledCSS] = useState(
    Boolean(value.advanced_css) &&
      !isOnSiteLayoutFixOnly(value.advanced_css, layoutType, css)
  );
  const font = useSelector(
    (state) => state.setting.productSetting.uploadedFonts
  );
  useEffect(() => {
    if (
      value.advanced_css &&
      !isOnSiteLayoutFixOnly(value.advanced_css, layoutType, css)
    ) {
      setEnabledCSS(true);
    } else {
      setEnabledCSS(false);
    }
  }, [value.advanced_css, layoutType, css]);

  // const isSaveEnabled = theme?.name?.trim();
  // useEffect(() => {
  //   if (editMode) {
  //     setIsBasicAttributesVisible(true);
  //   }
  // }, [editMode]);

  // useEffect(() => {
  //   if (createLoading) {
  //     setTheme({});
  //     setCSS('');
  //     setShowThemeAttributes(false);
  //     false;
  //   }
  // }, [createLoading]);
  const getAttributesForLayout = (channel, layoutType) => {
    return layoutConfigurations[channel]?.[layoutType] || [];
  };

  const attributes = getAttributesForLayout(channel, layoutType);

  const addOrUpdateAction = (actions, index, newAction) => {
    if (actions.length <= index) {
      const additionalActions = Array(index - actions.length + 1).fill({});
      actions = [...actions, ...additionalActions];
    }

    return actions.map((action, i) =>
      i === index ? { ...action, ...newAction } : action
    );
  };

  return (
    <div
      className="theme-attributes-container"
      style={{
        pointerEvents: editMode ? 'none' : 'auto',
        opacity: editMode ? '0.5' : '1',
      }}
    >
      <div className="inner">
        {layoutType !== 'IMAGE_ONLY' && (
          <Checkbox
            disabled={readOnly}
            style={{ marginBottom: 8 }}
            checked={isBasicAttributesVisible}
            onChange={(e) => {
              setIsBasicAttributesVisible(e.target.checked);

              handleChangeProps({});
            }}
          >
            Basic Theme Attributes
          </Checkbox>
        )}

        {isBasicAttributesVisible && (
          <div className="basic-attributes">
            <div
              className="layout-options"
              style={{
                pointerEvents: editMode ? 'none' : 'auto',
                opacity: editMode ? '0.5' : '1',
                paddingTop: 8,
              }}
            >
              {attributes.includes('label') && (
                <div className="theme-item">
                  <label className="theme-label">Label</label>
                  <div className="color-picker-attribute">
                    <Input
                      disabled={readOnly}
                      value={value?.label?.color}
                      className="color-input"
                      type="color"
                      onChange={(val) =>
                        handleChangeProps({
                          ...value,

                          label: { ...value.label, color: val.target.value },
                        })
                      }
                      style={{ width: '100%' }}
                    />
                    <Input
                      disabled={readOnly}
                      value={value?.label?.color}
                      className="text-input"
                      maxLength={7}
                      onChange={(val) =>
                        handleChangeProps({
                          ...value,

                          label: { ...value.label, color: val.target.value },
                        })
                      }
                      style={{ marginTop: 4 }}
                    />
                  </div>
                </div>
              )}
              {attributes.includes('title') && (
                <div className="theme-item">
                  <label className="theme-label">Title</label>
                  <div className="color-picker-attribute">
                    <Input
                      disabled={readOnly}
                      value={value?.title?.color}
                      className="color-input"
                      type="color"
                      onChange={(val) =>
                        handleChangeProps({
                          ...value,

                          title: { ...value.title, color: val.target.value },
                        })
                      }
                      style={{ width: '100%' }}
                    />
                    <Input
                      disabled={readOnly}
                      value={value?.title?.color}
                      className="text-input"
                      maxLength={7}
                      onChange={(val) =>
                        handleChangeProps({
                          ...value,

                          title: { ...value.title, color: val.target.value },
                        })
                      }
                      style={{ marginTop: 4 }}
                    />
                  </div>
                </div>
              )}
              {attributes.includes('message') && (
                <div className="theme-item">
                  <label className="theme-label">Message</label>
                  <div className="color-picker-attribute">
                    <Input
                      disabled={readOnly}
                      value={value?.message?.color}
                      className="color-input"
                      type="color"
                      onChange={(val) =>
                        handleChangeProps({
                          ...value,

                          message: {
                            ...value.message,
                            color: val.target.value,
                          },
                        })
                      }
                      style={{ width: '100%' }}
                    />
                    <Input
                      disabled={readOnly}
                      value={value?.message?.color}
                      className="text-input"
                      maxLength={7}
                      onChange={(val) =>
                        handleChangeProps({
                          ...value,

                          message: {
                            ...value.message,
                            color: val.target.value,
                          },
                        })
                      }
                      style={{ marginTop: 4 }}
                    />
                  </div>
                </div>
              )}
              {attributes.includes('coupon') && (
                <>
                  <div className="theme-item">
                    <label className="theme-label"> Coupon Code</label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.coupon?.color}
                        className="color-input"
                        type="color"
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            coupon: {
                              ...value.coupon,
                              color: val.target.value,
                            },
                          })
                        }
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.coupon?.color}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            coupon: {
                              ...value.coupon,
                              color: val.target.value,
                            },
                          })
                        }
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                  <div className="theme-item">
                    <label className="theme-label">
                      {' '}
                      Coupon Code background
                    </label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.cta_background_coupon}
                        className="color-input"
                        type="color"
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            cta_background_coupon: val.target.value,
                          })
                        }
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.cta_background_coupon}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            cta_background_coupon: val.target.value,
                          })
                        }
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                </>
              )}
              {attributes.includes('coupon_button') && (
                <>
                  <div className="theme-item">
                    <label className="theme-label"> Coupon Button</label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.coupon_button?.color}
                        className="color-input"
                        type="color"
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            coupon_button: {
                              ...value.coupon_button,
                              color: val.target.value,
                            },
                          })
                        }
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.coupon_button?.color}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            coupon_button: {
                              ...value.coupon_button,
                              color: val.target.value,
                            },
                          })
                        }
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                  <div className="theme-item">
                    <label className="theme-label">
                      {' '}
                      coupon Button Background hover
                    </label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.coupon_button?.hover_color}
                        className="color-input"
                        type="color"
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            coupon_button: {
                              ...value.coupon_button,
                              hover_color: val.target.value,
                            },
                          })
                        }
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.coupon_button?.hover_color}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,

                            coupon_button: {
                              ...value.coupon_button,
                              hover_color: val.target.value,
                            },
                          })
                        }
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                </>
              )}
              {attributes.includes('primary-button') && (
                <>
                  <div className="theme-item">
                    <label className="theme-label">
                      {' '}
                      Primary button Background
                    </label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[0]?.bg_color}
                        className="color-input"
                        type="color"
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,
                            actions:
                              value.actions && value.actions.length > 0
                                ? value.actions.map((action, index) =>
                                    index === 0
                                      ? {
                                          ...action,
                                          bg_color: val.target.value,
                                        }
                                      : action
                                  )
                                : [
                                    {
                                      bg_color: val.target.value,
                                    },
                                  ],
                          })
                        }
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[0]?.bg_color}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,
                            actions: value.actions
                              ? value.actions.map((action, index) =>
                                  index === 0
                                    ? {
                                        ...action,
                                        bg_color: val.target.value,
                                      }
                                    : action
                                )
                              : [
                                  {
                                    bg_color: val.target.value,
                                  },
                                ],
                          })
                        }
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                  <div className="theme-item">
                    <label className="theme-label">Primary Text Button</label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[0]?.style?.color}
                        className="color-input"
                        type="color"
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,
                            actions:
                              value.actions && value.actions.length > 0
                                ? value.actions.map((action, index) =>
                                    index === 0
                                      ? {
                                          ...action,
                                          style: {
                                            ...action.style,
                                            color: val.target.value,
                                          },
                                        }
                                      : action
                                  )
                                : [
                                    {
                                      style: {
                                        font_size: 18,
                                        color: val.target.value,
                                      },
                                    },
                                  ],
                          })
                        }
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[0]?.style?.color}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,
                            actions: value.actions
                              ? value.actions.map((action, index) =>
                                  index === 0
                                    ? {
                                        ...action,
                                        style: {
                                          ...action.style,
                                          color: val.target.value,
                                        },
                                      }
                                    : action
                                )
                              : [
                                  {
                                    style: {
                                      font_size: 18,
                                      color: val.target.value,
                                    },
                                  },
                                ],
                          })
                        }
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                </>
              )}
              {attributes.includes('secondary-button') && (
                <>
                  <div className="theme-item">
                    <label className="theme-label">
                      Secondary button Background
                    </label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[1]?.bg_color}
                        className="color-input"
                        type="color"
                        onChange={(val) => {
                          handleChangeProps({
                            ...value,
                            actions: addOrUpdateAction(value.actions || [], 1, {
                              ...value?.actions?.[1],
                              bg_color: val.target.value,
                            }),
                          });
                        }}
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[1]?.bg_color}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) => {
                          handleChangeProps({
                            ...value,
                            actions: addOrUpdateAction(value.actions || [], 1, {
                              ...value?.actions?.[1],
                              bg_color: val.target.value,
                            }),
                          });
                        }}
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                  <div className="theme-item">
                    <label className="theme-label">Secondary Text button</label>
                    <div className="color-picker-attribute">
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[1]?.style?.color}
                        className="color-input"
                        type="color"
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,
                            actions: addOrUpdateAction(value.actions || [], 1, {
                              style: {
                                ...value?.actions?.[1]?.style,
                                color: val.target.value,
                              },
                            }),
                          })
                        }
                        style={{ width: '100%' }}
                      />
                      <Input
                        disabled={readOnly}
                        value={value?.actions?.[1]?.style?.color}
                        className="text-input"
                        maxLength={7}
                        onChange={(val) =>
                          handleChangeProps({
                            ...value,
                            actions: addOrUpdateAction(value.actions || [], 1, {
                              style: {
                                ...value?.actions?.[1]?.style,
                                color: val.target.value,
                              },
                            }),
                          })
                        }
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  </div>
                </>
              )}
              {attributes.includes('border-radius') && (
                <div className="theme-item">
                  <label className="theme-label">Border Radius</label>
                  <InputNumber
                    disabled={readOnly}
                    value={value?.border_radius}
                    addonAfter={'px'}
                    onChange={(val) =>
                      handleChangeProps({
                        ...value,

                        border_radius: val,
                      })
                    }
                  />
                </div>
              )}
              {/* TODO: font value for survey is id */}
              {attributes.includes('font') && (
                <div className="theme-item">
                  <label className="theme-label">Font</label>
                  <Select
                    disabled={readOnly}
                    value={value?.title?.font_family}
                    style={{ width: 216 }}
                    showSearch
                    optionFilterProp="children"
                    onChange={(val) => {
                      const selectedFont = JSON.parse(val);
                      handleChangeProps({
                        ...value,
                        title: {
                          ...value.title,
                          font_family: selectedFont.fileName,
                          src: selectedFont.src,
                        },
                        message: {
                          ...value.message,
                          font_family: selectedFont.fileName,
                          src: selectedFont.src,
                        },
                        label: {
                          ...value.label,
                          font_family: selectedFont.fileName,
                          src: selectedFont.src,
                        },
                        coupon: {
                          ...value.coupon,
                          font_family: selectedFont.fileName,
                          src: selectedFont.src,
                        },
                      });
                    }}
                  >
                    {font?.map((font) => (
                      <Option
                        key={normalizeFont(font.file.fileName)}
                        value={JSON.stringify({
                          fileName: normalizeFont(font.file.fileName),
                          src: font.file.publicPath,
                        })}
                      >
                        {font.file.fileName}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
              {attributes.includes('font-size') && (
                <div className="theme-item">
                  <label className="theme-label">Font size</label>
                  <Select
                    disabled={readOnly}
                    value={value?.title?.font_size}
                    style={{ width: 216 }}
                    onChange={(val) =>
                      handleChangeProps({
                        ...value,

                        label: { ...value.label, font_size: val },
                        title: { ...value.title, font_size: val },
                        message: { ...value.message, font_size: val },
                        coupon: { ...value.coupon, font_size: val },
                        actions: addOrUpdateAction(value.actions || [], 0, {
                          style: {
                            ...value?.actions?.[0]?.style,
                            font_size: val,
                          },
                        }),
                      })
                    }
                  >
                    {fontSizes.map((value) => (
                      <Option key={value} value={value}>
                        {value}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
            </div>
          </div>
        )}

        <Checkbox
          disabled={readOnly}
          checked={enabledCSS}
          onChange={(e) => {
            const isChecked = e.target.checked;
            setEnabledCSS(isChecked);
            // Never auto-fill OnSite advanced_css when off — API rejects the
            // current template CSS (aspect-ratio / etc.).
            handleChangeProps({
              ...value,
              advanced_css: isChecked
                ? css[layoutType] ||
                  getOnSiteDefaultAdvancedCss(layoutType, css)
                : '',
            });
          }}
          style={{ whiteSpace: 'pre-wrap' }}
        >
          Advanced Styling
        </Checkbox>
        {enabledCSS && (
          <ThemeCSSEditor
            value={
              value.advanced_css ||
              css[layoutType] ||
              getOnSiteDefaultAdvancedCss(layoutType, css)
            }
            onChange={(val) =>
              handleChangeProps({
                ...value,
                advanced_css: val,
              })
            }
          />
        )}
      </div>
    </div>
  );
}
